import { useRouter } from 'next/router'
import { useEffect } from 'react'

import useSKPPelaksanaanTrackEvent from 'app/KinerjaPage/hooks/useSKPPelaksanaanTrackEvent'
import { CekHasilTindakLanjut } from 'app/KinerjaPage/pages/PelaksanaanV2/components/CekHasilTindakLanjut'
import { Header } from 'app/KinerjaPage/pages/PelaksanaanV2/components/Header'
import { PENGELOLAAN_KINERJA_GURU_PATH } from 'app/KinerjaShared/constants/path'

export function DokumenTindakLanjutStep1() {
  const router = useRouter()

  const { trackEvent } = useSKPPelaksanaanTrackEvent()
  const CURRENT_SCREEN_NAME = 'form_c'
  const ENTRY_POINT = 'pelaksanaan_hub'

  useEffect(() => {
    trackEvent({
      activity_type: 'pelaksanaan_open_form_c',
      screen_name: CURRENT_SCREEN_NAME,
      event_trigger: ENTRY_POINT,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClickNext = () => {
    router.push(
      `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/dokumen-tindak-lanjut/detail`
    )
    trackEvent({
      activity_type: 'pelaksanaan_click_form_c_lanjut',
      screen_name: CURRENT_SCREEN_NAME,
      event_trigger: ENTRY_POINT,
    })
  }

  const handleClickBack = () => {
    router.back()
    trackEvent({
      activity_type: 'pelaksanaan_click_form_c_back',
      screen_name: CURRENT_SCREEN_NAME,
      event_trigger: ENTRY_POINT,
    })
  }

  return (
    <>
      <Header
        title="Rencana Tindak Lanjut"
        className="mb-9"
        onBack={handleClickBack}
      />

      <CekHasilTindakLanjut
        onNext={handleClickNext}
        nextButtonText={<>Ke Rencana Tindak Lanjut</>}
      />
    </>
  )
}
